/**
 * @vuepress
 * ---
 * title: file
 * ---
 */
import moment from 'moment'
import Transformer from '@/transformers/transformer'

/**
 * @class billingTransformer
 * billing request file transformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */
class billingTransformer extends Transformer {
  /**
   * Transform file to send
   *
   * @param file to send file
   *
   * @returns {Object} The transformed file
   */

  static send(file) {
    const formData = new FormData()
    formData.append('file', file.file.target.files[0])
    formData.append('affected_id', file.affected)
    formData.append('visible_customer', false)
    // formData.append('visible_customer', file.visibleCustomer)
    formData.append('date_content', moment(file.date).format() || null)
    return formData
  }

}

export default billingTransformer


// WEBPACK FOOTER //
// ./src/transformers/Files/billingRequest.js